import TravelItineraryApp from "./TravelItineraryApp";

function App() {
  return (
      <TravelItineraryApp></TravelItineraryApp>
  );
}

export default App;
